import { useEffect, useRef } from "react";
import useFrontendEvents from "hooks/useFrontendEvents";

export default function useLogFrontendEvents({ eventableId, eventableType, key, payload = {} }) {
  const { handleAddFrontendEvent } = useFrontendEvents();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (eventableId && !loggedRef.current) {
      handleAddFrontendEvent({
        key,
        eventableId,
        eventableType,
        payload,
      });
      loggedRef.current = true;
    }
  }, [eventableId, eventableType, payload, key]);
}
